export const TasksApiPath = {
  DALOG_ACTIONS: '/dalog-actions/api',
  HROC_CHECKLISTS: '/hroc-checklists/api',
  MACHINE_SENTRY_ACTIONS: '/machine-sentry-actions/api',
  OIL_ANALYSIS_ACTIONS: '/oil-analysis-actions/api',
  POM_QUESTIONNARIES: '/pom-questionnaires',
  PROCESS_WORK_ORDERS: '/process-work-orders/api',
  SHIFT_HANDOVER: '/shifthandover',
  TASKS: '/tasks',
  USERS: '/users'
} as const
